import { computed } from 'vue'
import { useRoute } from 'vue-router'

export function useVirtualGame () {
  const route = useRoute()

  const sports = new Map(
    [
      [
        1, {
        id: 1,
        name: 'BET365축구',
        leagues: [
          {
            id: 1,
            name: 'Euro Cup',
            name_ko: '유로컵',
            url: 'http://b1.nust365.com/ios/?vn=13',
          },
          {
            id: 2,
            name: 'World Cup',
            name_ko: '월드컵',
            url: 'http://b1.nust365.com/ios/?vn=3',
          },
          {
            id: 3,
            name: 'Premiership',
            name_ko: '프리미어',
            url: 'http://b1.nust365.com/ios/?vn=1',
          },
          {
            id: 4,
            name: 'Superleague',
            name_ko: '수퍼리그',
            url: 'http://b1.nust365.com/ios/?vn=2',
          },
        ],
      }],
      [
        2, {
        id: 2,
        name: 'BET365개경주',
        leagues: [
          {
            id: 1,
            name: 'Bennett Park',
            name_ko: '배넷 공원',
            url: 'http://b2.nust365.com/ios/?vn=9',
          },
          {
            id: 2,
            name: 'Goldenhill Park',
            name_ko: '골든힐 공원',
            url: 'http://b2.nust365.com/ios/?vn=5',
          },
          {
            id: 3,
            name: 'Hillside Park',
            name_ko: '힐사이드 공원',
            url: 'http://b2.nust365.com/ios/?vn=4',
          },
        ],
      }],
      [
        4, {
        id: 4,
        name: 'BET365 농구',
        leagues: [
          // {
          //   id: 1,
          //   name: 'Baker Gardens',
          //   name_ko: 'Baker Gardens',
          //   url: 'https://b4.nust365.com/ios/?vn=11',
          // },
          {
            id: 2,
            name: 'Waterport Arena',
            name_ko: 'Waterport Arena',
            url: 'https://b4.nust365.com/ios/?vn=12',
          },
          {
            id: 3,
            name: 'NBA Replay',
            name_ko: 'NBA Replay',
            url: 'https://b4.nust365.com/ios/?vn=17',
          },
        ],
      }],
      [
        6, {
        id: 6,
        name: 'BWIN축구',
         leagues: [
          {
            id: 1,
            name: 'Euro Cup',
            name_ko: '유로컵',
            url: 'https://bwin.nust365.com/?vn=1',
          },
          {
            id: 2,
            name: 'Champions Cup',
            name_ko: '챔피언스컵',
            url: 'https://bwin.nust365.com/?vn=2',
          },
          {
            id: 3,
            name: 'World Cup',
            name_ko: '월드컵',
            url: 'https://bwin.nust365.com/?vn=3',
          },
          {
            id: 4,
            name: 'Superliga America do Sul',
            name_ko: '슈퍼리그',
            url: 'https://bwin.nust365.com/?vn=4',
          },
           {
            id: 5,
            name: 'Liga Americas',
            name_ko: '리가 아메리카',
            url: 'https://vses-fr.ptvirtuals.com/vr-media-schedule/MediaViewer?operator=bwin&sportType=FOOTBALL_MATCH&oddsFormat=decimal&language=en',
          },
        ],
      }],
      [
        7, {
        id: 7,
        name: 'BWIN 농구',
         leagues: [
          {
            id: 1,
            name: 'US League',
            name_ko: 'US리그',
            url: 'https://bwin.nust365.com/?vn=5',
          },
          {
            id: 2,
            name: 'Euro League',
            name_ko: '유로리그',
            url: 'https://bwin.nust365.com/?vn=6',
          },
          {
            id: 3,
            name: 'US Arena',
            name_ko: 'US아레나',
            url: 'https://vses-fr.ptvirtuals.com/vr-media-schedule/MediaViewer?operator=bwin&sportType=BASKETBALL&oddsFormat=decimal&language=en',
          },
        ],
      }],
      [
        8, {
        id: 8,
        name: 'BWIN 럭비',
         leagues: [
          {
            id: 1,
            name: 'NFL League - Lee Fields',
            name_ko: 'NFL League - Lee Fields',
            url: 'https://bwin.nust365.com/?vn=9',
          },        {
            id: 2,
            name: 'NFL League - The Berg Bowl',
            name_ko: 'NFL League - The Berg Bowl',
            url: 'https://bwin.nutv365.com/?vn=10',
          },
        ],
      }],
    ],
  )

  const leagues = {
    'Euro Cup': '유로컵',
    'World Cup': '월드컵',
    'Premiership': '프리미어',
    'Superleague': '수퍼리그',
    'Bennett Park': '배넷 공원',
    'Goldenhill Park': '골든힐 공원',
    'Hillside Park': '힐사이드 공원',
    'Baker Gardens': 'Baker Gardens',
    'Waterport Arena': 'Waterport Arena',
    'NBA Replay': 'NBA Replay',
    'Champions Cup': '챔피언스컵',
    'Superliga America do Sul': '슈퍼리그',
    'Liga Americas': '리가 아메리카',
    'US League': 'US리그',
    'Euro League': '유로리그',
    'US Arena': 'US아레나',
    'NFL League - Lee Fields': 'NFL League - Lee Fields',
    'NFL League - The Berg Bowl': 'NFL League - The Berg Bowl',
  }

  const sport = computed(() => sports.get(Number(route.params.sport)))
  const league = computed(() => sport.value.leagues.find(league => league.id === Number(route.params.league)))

  function transLeague (name) {
    return leagues[name]
  }

  return {
    sports,
    sport,
    league,
    transLeague,
  }
}
